module.exports = __webpack_public_path__ + "img/276-fb9058.png";